<question-description
  titleDir="left"
  subTitleDir="left"
  title="Quel type de souscription ?"
  subTitle="Choisissez le périmètre des documents à générer et faire signer."
>
</question-description>

<div class="row mb-4">
  @for (option of options; track option.value) {
    <div
      class="col-md-6 mt scope-card"
      (click)="select(option)"
      [ngClass]="selected === option.value ? 'active' : ''"
    >
      <residence-box
        [suffix]="option.suffix"
        [title]="option.title"
        [svg]="option.svg"
        [checked]="selected === option.value"
      >
        <div class="scope-subtitle">{{ option.subtitle }}</div>
      </residence-box>
    </div>
  }
</div>

<div class="btn-group">
  @if (showPrevious) {
    <pr-button
      size="lg"
      type="button"
      label="Question précédente"
      icon="arrow_left"
      (onClick)="prev()"
    ></pr-button>
  }
  <pr-button
    size="lg"
    type="button"
    display="neutral"
    label="Je détermine mon profil."
    [disabled]="!selected"
    (onClick)="confirm()"
  ></pr-button>
</div>
